
if ($(window).width() < 768) {
  $('.about-content .flexbox').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    arrows: false,
  });

  $('.top-items-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    arrows: false,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 2000
  });
  
}

/* featured-collection-new.liquid */
function featuredColl_div(eType = ''){
  $('.featuredCollSec .featuredColl-div').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,	
      infinite: true,          
      speed: 500, touchThreshold: 500,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
  });

$('.featuredColl-div.slick-initialized .card-information__wrapper .card-information__text').css('min-height','');
  var _height = 0;
  setTimeout(function(){
    if($(window).width() >= 768){
      $('.featuredColl-div.slick-initialized .card-information__wrapper .card-information__text').each(function(){
        $(this).css('min-height','');
        var _temp = $(this).outerHeight();
        if( _temp > _height ){
          _height = _temp;
        }  
      });
      if( _height > 0){
        $('.featuredColl-div.slick-initialized .card-information__wrapper .card-information__text').css('min-height',_height+'px');    
      } 
    }
  },250)
  
}
featuredColl_div();

//home page featured collection slider reinitialized
jQuery(window).resize(function(event){
  // console.log('width ' + $(window).width());
  if($(window).width() >= 768){
        featuredColl_div(event.type);
        // console.log("fc load");
      }else{
    setTimeout(function(){
        $('.featuredCollSec .featuredColl-div.slick-initialized').slick('unslick');
        $('.featuredColl-div:not(.slick-initialized) .card-information__wrapper .card-information__text').css('min-height','');
        // console.log("fc unslick");
      },100);
      }
});



  if($('.featuredCollSec .featuredColl-div').closest('.noBGColor').length > 0){    
    $('.featuredCollSec .featuredColl-div .noBGColor').closest('.featuredCollSec').addClass('overflowed');
  }
/* featured-collection-new.liquid &*/

jQuery(function(){
  jQuery("body").on('click', ".popup-opener", function(e){
    e.preventDefault();
    var $parents = jQuery(this).attr('data-popup-id');
    var $customPop = jQuery(this).attr('data-overlay');
    jQuery("div[data-popup='" + $parents + "']").addClass("active");
    if($customPop !== "false"){jQuery('.overlay').addClass("active");}
    jQuery("div[data-popup='" + $parents + "']").siblings(".dd-popup").removeClass("active");

  });

  jQuery("body").on('click', ".close-btn", function(e){
    e.preventDefault();
    var $parents = jQuery('.active').attr('data-popup');
    jQuery(this).closest(".dd-popup").removeClass("active");
    jQuery('.overlay').removeClass("active");
  });
  jQuery("body").on('click', ".overlay", function(e){
    e.preventDefault();
    var $parents = jQuery('.active').attr('data-popup');
    jQuery('.dd-popup').removeClass('active');
    jQuery('.overlay').removeClass("active");
  });
  jQuery(document).keyup(function(e) {
    
    if (e.keyCode == 27) {
      jQuery(".dd-popup").removeClass("active");
      jQuery('.overlay').removeClass("active");
    }
  });
  $(document).on('click','.btn-as-icon',function(){
    var data_id = $(this).attr('data-id');
    $('.mu-col-popup-wrapper[data-id="'+data_id+'"]').addClass('active');
  });
  
  $(document).on('click','.exit',function(){
    var data_id = $(this).closest('.mu-col-popup-wrapper').attr('data-id');
    $('.mu-col-popup-wrapper[data-id="'+data_id+'"]').removeClass('active');
  });
  
  $(document).on('click','.pop-overlay',function(){
    $(this).closest('.mu-col-popup-wrapper').removeClass('active');
  });

});


$(document).ready(function(){
  var announcmentBar = $('#shopify-section-announcement-bar .announcement-bar');
  if(announcmentBar.length > 0 ){
    $('#shopify-section-announcement-bar').addClass('announcement-active');
  }
});


$('.menu-drawer__inner-container .header__icon--menu .icon, .menu-drawer__inner-btn .header__icon--menu .icon').on('click',function(){
  $(this).closest('details.menu-drawer-container').find('summary[aria-label="Menu"]').trigger('click');
});


//cart-page multiple product


$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $("body").addClass("sticky-add-cart");
  } else{
    $("body").removeClass("sticky-add-cart");
  }
});


$(document).on('click','button[name="next"]',function(){
	var limit_size = $('.dots-wrapper').attr('data-limit');
	if(parseInt($('.dots-wrapper .dot-item.active').attr('data-count')) != limit_size){
	    var curr_slide = (parseInt($('.dots-wrapper .dot-item.active').attr('data-count')) + 1);
	    $('.product__media-list li').removeClass('active-slide');
	    $('.product__media-list li[data-count="'+curr_slide+'"]').addClass('active-slide');
	    $('.dots-wrapper .dot-item').removeClass('active');
	    $('.dots-wrapper .dot-item[data-count="'+curr_slide+'"]').addClass('active');
	}
});

$(document).on('click','button[name="previous"]',function(){
	var limit_size = $('.dots-wrapper').attr('data-limit');
	if((parseInt($('.dots-wrapper .dot-item.active').attr('data-count')) - 1) < limit_size && (parseInt($('.dots-wrapper .dot-item.active').attr('data-count')) - 1) > 0){
	    var curr_slide = (parseInt($('.dots-wrapper .dot-item.active').attr('data-count')) - 1);
	    $('.product__media-list li').removeClass('active-slide');
	    $('.product__media-list li[data-count="'+curr_slide+'"]').addClass('active-slide');
	    $('.dots-wrapper .dot-item').removeClass('active');
	    $('.dots-wrapper .dot-item[data-count="'+curr_slide+'"]').addClass('active');
	}
});


equalheight = function(container){
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    /*$($el).height('auto');*/
    $($el).css('min-height', '');
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        /*rowDivs[currentDiv].height(currentTallest);*/
        rowDivs[currentDiv].css('min-height', currentTallest+'px');
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    // console.log(rowDivs);
    for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      /*rowDivs[currentDiv].height(currentTallest);*/
      rowDivs[currentDiv].css('min-height', currentTallest+'px');
    }
  });
}

$(window).on('load resize', Debounce(function() {
  equalheight('.cW-individual .card-information__wrapper');
  if( window.innerWidth < 768 ) {
    $('#CartDrawer .recomnd-list.slick-initialized').slick('unslick');
  }
  
  if( $('#CartContainer').length ){
    var _minuHeight = $('#CartContainer .cart-drawer-footer').outerHeight() + $('#CartDrawer .drawer__header').outerHeight();
    _minuHeight = 'calc(100vh - '+_minuHeight+'px)';    
    $('#CartContainer').find('.ajaxcart__inner').css('height', _minuHeight );
  }

},250) );

function Debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};  






// triggers when gallery is ready
    document.addEventListener('galleryReady:covetPics', function(e) {
      // prepare CSS styles to inject
      const stylesPopup = document.createElement( 'style' )
      stylesPopup.innerHTML = `
         
	@media only screen and (max-width:767px){
		.gallery.grid { 
          scroll-padding: 0;
          overflow: hidden;
          overflow-x: auto;
          flex-wrap: nowrap;
          -webkit-overflow-scrolling: touch;
          -ms-overflow-style: -ms-autohiding-scrollbar;
          scroll-snap-type: x mandatory;
          list-style: none;
          display: flex;
          justify-content: space-between;
          padding: 0; 
          margin-right: -20px;
          padding-right: 15px; }

        .gallery.grid .grid-item { 
          width: 200px !important;
          max-width: 200px;
          min-width: 200px;
          scroll-snap-align: start;
        }
	 }

        `
      // get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)
      const popup = document.querySelector("covet-pics-widget");

      // now inject CSS code into shadow DOM
      popup.shadowRoot.appendChild(stylesPopup);
    });

    let temo_for_coll = 0;
    $(document).on("click",".featuredCollSec .showMoreBtn",function(e){
      e.preventDefault();
      $(this).closest('.featuredColl-inner').toggleClass("show_more-enabled");
      $(this).closest(".featuredColl-inner").children(".featuredColl-div").children(".featuredCollDiv-items-for_mob").fadeToggle(1000);
      if( temo_for_coll == 0 ){
        $(this).children(".text").text("SHOW LESS");
        temo_for_coll = 1;
      }
      else{
        $(this).children(".text").text("SHOW MORE");
        temo_for_coll = 0
      }
      
    });


$('.featuredColl-div1').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      centerMode: true,
      centerPadding: '400px',
      arrows: true,	
      infinite: true,          
      speed: 300,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 1,
            centerPadding: '250px'
          }
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1,
            centerPadding: '200px'
          }
        },
        {
          breakpoint: 992,
          settings: {
             slidesToShow: 1,
             centerPadding: '80px'
          }
        },
        {
          breakpoint: 768,
          settings: {
             slidesToShow: 2,
             centerPadding: '50px',
             adaptiveHeight: true
          }
        },
        {
          breakpoint: 600,
          settings: {
             slidesToShow: 1,
             centerPadding: '10px',
             centerMode: false,
             adaptiveHeight: true
          }
        }
      ]
  });

  /************************* Shop All COllection Click On Scroll **********************/
  $(".cat-list-two .absolute-link").click(function(e){
    if( $("#ProductGridContainer .inner_Collections").length > 0 ){
      e.preventDefault();
    }
    $("#ProductGridContainer .inner_Collections").removeClass("scroll-coll");
    var GetTitle = $(this).attr("title");
    let temp = 0;
    $("#ProductGridContainer .inner_Collections").each(function(){
      var GetColl = $(this).children(".collection").children(".icoll-wrapper").children("h2").html();
      // console.log(GetColl+"::::"+GetTitle);
      if(GetColl==GetTitle)
      {
        //alert("match"+GetColl);
        $(this).addClass("scroll-coll");
        $('html, body').animate({
          'scrollTop' : $(".scroll-coll").position().top-130
        });
        temp = 0;
        return false;
      }
      else{
        temp = 1;
      }
    });
    if(temp == 1) window.location.href =$(this).attr("href");
  })

  /****************************** START RADIO AND DROP-DOWN VARIANT LAYOUT ON PDP *****************************/ 
  $(document).ready(function(){
     $(".custom-variant-inner").click(function(){
    $(".custom-variant-inner").each(function(){
   $(this).removeClass("active-custom");
      })
    $(this).addClass("active-custom");
    var GetHTML = $(this).attr("data-name");
    $('.js.product-form__input input[type=radio]').each(function(){
      var ValueGet = $(this).attr("value");
      if(ValueGet==GetHTML){
        $(this).trigger("click");
      }
    })
  })
  })
    $(".drop-down-list-item").click(function(){
    $(".drop-down-list-item").each(function(){
   $(this).removeClass("selected-custom");
      })
    $(this).addClass("selected-custom");
    var GetHTML = $(this).attr("data-name");
    $(".selected-variant-value").html(GetHTML);
    $('.js.product-form__input input[type=radio]').each(function(){
      var ValueGet = $(this).attr("value");
      if(ValueGet==GetHTML){
        $(this).trigger("click");
      }
    })
  })  
  $(".selected-variant-value").click(function(){
    $(".drop-down-wrapper").addClass("custom-open");
  })
  function checkcursor(){
    if ($('#drop-down-list:hover').length!=0) {
    }
    else{
      $(".drop-down-wrapper").removeClass("custom-open");
    }
  }
  $(window).scroll(function() { 
    if ($('#drop-down-list:hover').length!=0) {
      setTimeout(function(){
         checkcursor();
      }, 1000);
    }
    else{
      $(".drop-down-wrapper").removeClass("custom-open");
    }
  })
  $(document).on('click', function (event) {
  if (!$(event.target).closest('#drop-down-wrapper').length) {
    $(".drop-down-wrapper").removeClass("custom-open");
  }
    
  });
  /****************************** END RADIO AND DROP-DOWN VARIANT LAYOUT ON PDP *****************************/ 

  $(document).ready(function () {
    // Check if the current URL contains "https://movewithascend.com/fr"
    if (window.location.href.includes("https://movewithascend.com/fr")) {
        // Find the link with the specific href and update it
        $('a[href="https://support.movewithascend.com/hc/en-us"]').attr('href', 'https://support.movewithascend.com/hc/fr-ca');
    }
});